// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"e1b46a61","497":"fae46e93","663":"83970c26","938":"e95095b5"}[chunkId] + ".chunk.css";
};